import React from "react"
import Stack from '@mui/material/Stack'
import CopyrightIcon from '@mui/icons-material/Copyright'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

const thisDate = new Date()

const Transparency = styled('div')(({ theme }) => ({
    color: "rgba(0,0,0,0.5)"
}));

export default function Footer(props) {
    const {marginTop} = props

    return (<>   
        <Stack
            direction="column"
            justifyContent="space-evenly"
            alignItems="center"
            sx={{ marginTop: marginTop }}
        >
            <Transparency>
                <Stack
                    direction="row"
                    justifyContent="space-evenly"
                    alignItems="center"
                    spacing={.5}
                >           
                    <Typography variant="p">
                        Ignacio Rivano
                    </Typography>       
                    <CopyrightIcon/>   
                    <Typography variant="p">
                        {thisDate.getFullYear()}
                    </Typography>  
                </Stack>        
            </Transparency>
        </Stack>
    </>)
}

Footer.defaultProps = {
    marginTop: 10
}